// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7100":"3933d7c1","7205":"93a63caf","9054":"45e10f07"}[chunkId] + ".chunk.css";
};